import React from "react";
import { useDispatch } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import { BaseURL } from "../components/Common";

import BSL_TextInput from "../components/BSL_TextInput";
import BSL_ControlContainer from "../components/BSL_ControlContainer";
import * as BSL_Common from "../components/BSL_CommonControls";
import { IconButton, Paper, Popper } from "@material-ui/core";
import { Palette } from "../AppConfig";
import SegmentedButtonGroup from "../components/SegmentedButtonGroup";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import CloseIcon from "@material-ui/icons/Close";
import BSL_Button from "../components/BSL_Button";
import DeleteIcon from "@material-ui/icons/Delete";
import WarningIcon from "@material-ui/icons/Warning";
import Autocomplete from "react-autocomplete";

const createThumb = (filename) => {
    if (!filename) return "";
    return (
        <>
            {filename}
            <img
                style={{
                    marginLeft: "5px",
                    width: "2.5rem",
                    height: "1.5rem",
                    verticalAlign: "middle",
                    opacity: filename.includes("_trans") || filename.includes("_skylight") ? "0.5" : 1.0,
                }}
                src={BaseURL("models/textures/" + filename)}
            />
        </>
    );
};

const texture_files = [
    { Key: "", Display: "None" },
    {
        Key: "corro.jpg",
        Display: createThumb("corro.jpg"),
    },
    {
        Key: "cdeck.png",
        Display: createThumb("cdeck.png"),
    },
    {
        Key: "flatdek.png",
        Display: createThumb("flatdek.png"),
    },
    {
        Key: "flatdekii.png",
        Display: createThumb("flatdekii.png"),
    },
    {
        Key: "hirib.png",
        Display: createThumb("hirib.png"),
    },
    {
        Key: "kliplok.png",
        Display: createThumb("kliplok.png"),
    },
    {
        Key: "kliplokclassic.png",
        Display: createThumb("kliplokclassic.png"),
    },
    {
        Key: "spandek.jpg",
        Display: createThumb("spandek.jpg"),
    },
    {
        Key: "trimdek.png",
        Display: createThumb("trimdek.png"),
    },
    {
        Key: "corro_trans.png",
        Display: createThumb("corro_trans.png"),
    },
    {
        Key: "tl5_trans.png",
        Display: createThumb("tl5_trans.png"),
    },
    {
        Key: "greca_trans.png",
        Display: createThumb("greca_trans.png"),
    },
    {
        Key: "cdeck_skylight.png",
        Display: createThumb("cdeck_skylight.png"),
    },
];

const bottom_texture_files = [
    { Key: "", Display: "None" },
    {
        Key: "solarspan_vj.png",
        Display: createThumb("solarspan_vj.png"),
    },
    {
        Key: "solarspan_smooth.png",
        Display: createThumb("solarspan_smooth.png"),
    },
];

const useStyles = makeStyles((theme) => ({
    root: {
        flex: 1,
        maxWidth: "90%",
        minWidth: "600px",
    },
    container: {
        // height: "90%",
        // maxHeight: "800px",
    },
    row: {
        "tr:hover": {
            backgroundColor: "rgb(7, 50, 50, 0.42)",
        },
    },
    rowCell: {
        fontSize: "12px",
        border: "none",
        padding: "2px 0px 2px 24px",
        color: theme.brand.FIELDERS ? "inherit" : Palette.Lysaght.MidGrey,
        "&:hover": {
            backgroundColor: "rgb(7, 177, 77, 0.42)",
            cursor: "pointer",
        },
    },
    categoryHeadingCell: {
        textAlign: "center",
        backgroundColor: Palette.FieldersOrange + " !important",
        padding: "2px !important",
        borderTopLeftRadius: "5px",
        borderTopRightRadius: "5px",
        borderLeft: "1px solid white !important",
        borderRight: "1px solid white !important",
        position: "sticky",
        top: "0px !important",
    },
    categoryHeadingCellBlank: {
        textAlign: "center",
        backgroundColor: "#ffffff !important",
        padding: "2px !important",
        position: "sticky",
        top: "0px !important",
    },
    headingCell: {
        fontSize: "11px",
        border: "none",
        // padding: "2px 0px 2px 24px",
        textTransform: "uppercase",
        color: "#ffffff",
        fontWeight: theme.brand.FIELDERS ? "inherit" : "600",
        fontFamily: theme.typography.fontFamilySecondary,
        backgroundColor: "#a8a8a8",
        lineHeight: "normal",
        zIndex: "5",
        top: "15px",
    },
    headingCellSubtype: {
        fontSize: "11px",
        border: "none",
        // padding: "2px 0px 2px 24px",
        textTransform: "uppercase",
        color: "#ffffff",
        fontWeight: theme.brand.FIELDERS ? "inherit" : "600",
        fontFamily: theme.typography.fontFamilySecondary,
        backgroundColor: "#878787",
        lineHeight: "normal",
        zIndex: "5",
        top: "15px",
    },

    headingRow: {
        backgroundColor: Palette.FieldersBlue,
    },
    skylightheadingCell: {
        background: "#5ebba7",
    },
    editor: {
        border: "1px solid grey",
        width: "40px",
    },
    noHover: {
        "&:hover": {
            backgroundColor: "transparent !important",
        },
    },
}));

const LYSAGHT_POAs = ["DEFAULT", "LSB", "EMU", "NUN", "LAU", "GIL", "KEW"];
const CENTENARY_POAs = ["DEFAULT", "MEN", "CAM", "MIN", "WAN"];

const subtype_columns = (roofSheetIDs, colours) => [
    {
        id: "Key",
        label: "Offering Key",
        style: {
            width: "100px",
            position: "sticky",
            left: "0",
            zIndex: "3",
            fontWeight: "600",
        },
    },
    {
        id: "name",
        label: "Display Name",
        style: {
            width: "100px",
        },
    },
    {
        id: "allow_nofoot_traffic",
        label: "Allow No Foot Traffic",
        grouping: "SUBTYPES - No Foot Traffic",
        style: {
            width: "100px",
        },
        format: (val, row) => (val === false ? "No" : "Yes"),
        select: [
            { Key: false, Display: "No" },
            { Key: true, Display: "Yes" },
        ],
    },
    {
        id: "roofsheet_id",
        label: "Roofsheet ID",
        style: {
            width: "100px",
        },
    },
    {
        id: "roofsheet_id_ds",
        label: "Roofsheet ID (Double Sided)",
        grouping: "SUBTYPES - No Foot Traffic",
        style: {
            width: "100px",
        },
        autocompleteOptions: roofSheetIDs,
    },
    {
        id: "max_overhang",
        label: "Max Overhang",
        grouping: "SUBTYPES - No Foot Traffic",
        style: {
            width: "100px",
        },
    },
    {
        id: "allow_non_trafficable",
        label: "Allow Non-Trafficable",
        grouping: "SUBTYPES - Non-Trafficable",
        style: {
            width: "100px",
        },
        format: (val, row) => (val === true ? "Yes" : "No"),
        select: [
            { Key: false, Display: "No" },
            { Key: true, Display: "Yes" },
        ],
    },
    {
        id: "roofsheet_id_non_trafficable",
        label: "Roofsheet ID",
        grouping: "SUBTYPES - Non-Trafficable",
        style: {
            width: "100px",
        },
        autocompleteOptions: roofSheetIDs,
    },
    {
        id: "roofsheet_id_non_trafficable_ds",
        label: "Roofsheet ID (Double Sided)",
        grouping: "SUBTYPES - Non-Trafficable",
        style: {
            width: "100px",
        },
        autocompleteOptions: roofSheetIDs,
    },
    {
        id: "max_overhang_non_trafficable",
        label: "Max Overhang",
        grouping: "SUBTYPES - Non-Trafficable",
        style: {
            width: "100px",
        },
    },
    {
        id: "allow_cyclonic",
        label: "Allow Cyclonic",
        grouping: "SUBTYPES - Cyclonic",
        style: {
            width: "100px",
        },
        format: (val, row) => (val === true ? "Yes" : "No"),
        select: [
            { Key: false, Display: "No" },
            { Key: true, Display: "Yes" },
        ],
    },
    {
        id: "colours",
        label: "Colours",
        grouping: "Specifications",
        style: {
            width: "100px",
        },

        format: (value) => {
            if (value && typeof value === "string" && value?.split !== undefined && colours) {
                let list = value.split(",");
                let output = [];
                for (let colour of list) {
                    if (colours.includes(colour.trim()))
                        output.push(<span>{(output.length === 0 ? "" : ",") + colour}</span>);
                    else
                        output.push(
                            <span style={{ color: "orange" }}>
                                {(output.length === 0 ? "" : ",") + colour}{" "}
                                <WarningIcon
                                    style={{
                                        width: "17px",
                                        height: "13px",
                                        color: "#e29d35",
                                    }}
                                />
                            </span>
                        );
                }
                return output;
            } else if (value && typeof value === "object") {
                let output = [];
                for (let poa in value) {
                    let colour = value[poa];
                    if (!colour) continue;
                    if (colours.includes(colour.trim()))
                        output.push(
                            <>
                                <span>
                                    {poa} - {colour}
                                </span>
                                <br />
                            </>
                        );
                    else
                        output.push(
                            <>
                                <span style={{ color: "orange" }}>
                                    {poa} - {colour}{" "}
                                    <WarningIcon
                                        style={{
                                            width: "17px",
                                            height: "13px",
                                            color: "#e29d35",
                                        }}
                                    />
                                </span>
                                <br />
                            </>
                        );
                }
                return output;
            }
            return value;
        },
        editor: (editCell, brand) => {
            let poas = brand === "Lysaght" ? LYSAGHT_POAs : CENTENARY_POAs;

            let values = editCell?.value;
            if (typeof editCell?.value === "string") {
                values = {
                    DEFAULT: editCell?.value,
                };
            }

            return (
                <BSL_Common.SectionColumn
                    style={{
                        paddingTop: "20px",
                    }}
                >
                    {poas.map((poa, index) => {
                        return (
                            // {
                            //     {item}
                            // }
                            <BSL_Common.SectionRow
                                style={{
                                    fontSize: "16px",
                                    alignItems: "center",
                                }}
                            >
                                <div
                                    style={{
                                        flex: 1,
                                        textAlign: "left",
                                    }}
                                >
                                    {poa}:
                                </div>
                                <Autocomplete
                                    items={colours}
                                    shouldItemRender={(item, value) => {
                                        // if (editCell?.column?.autocompleteShowFullList) return true;
                                        if (item.toLowerCase().startsWith(value.toLowerCase().substring(0, 3)))
                                            return true;
                                        if (item.toLowerCase().indexOf(value.toLowerCase()) > -1) return true;
                                        return false;
                                    }}
                                    getItemValue={(item) => item}
                                    autoHighlight={false}
                                    renderItem={(item, highlighted) => (
                                        <div
                                            key={item.id}
                                            style={{ backgroundColor: highlighted ? "#eee" : "transparent" }}
                                        >
                                            {item}
                                        </div>
                                    )}
                                    menuStyle={{
                                        zIndex: "999999",
                                        position: "absolute",
                                        backgroundColor: "whitesmoke",
                                        boxShadow: "1px 1px 4px",
                                        fontSize: "12px",
                                        left: "auto",
                                        top: "auto",
                                        marginLeft: "9px",
                                        // marginTop: "-33px",
                                        lineHeight: 1.4,
                                        width: "350px",
                                        textAlign: "left",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        overflowY: "auto",
                                        maxHeight: "300px",
                                    }}
                                    inputProps={{
                                        style: {
                                            font: "200 12px Univers45",
                                            width: "95%",
                                            padding: "4px 0px 4px 8px !important",
                                        },
                                    }}
                                    renderInput={(props) => {
                                        return (
                                            <BSL_TextInput
                                                // label={editCell?.column?.label}
                                                style={{ width: "300px", color: "white" }}
                                                value={values?.[poa] ? values?.[poa] : ""}
                                                tight={true}
                                                InputProps={{
                                                    style: { fontSize: "80%" },
                                                    ...props,
                                                }}
                                                // onEnter={(e) =>
                                                //     saveValue(
                                                //         editCell.section,
                                                //         editCell.key,
                                                //         editCell.row,
                                                //         editCell?.column?.id,
                                                //         e.target.value
                                                //     )
                                                // }
                                                onChange={(val) => {
                                                    let new_values = { ...values };
                                                    new_values[poa] = val;
                                                    if (val.trim() === "") delete new_values[poa];
                                                    if (Object.keys(new_values).length < 2)
                                                        new_values = new_values?.["DEFAULT"];
                                                    editCell.setEditCell({
                                                        ...editCell,
                                                        value: new_values ? new_values : "",
                                                    });
                                                }}
                                                helperText={index === 0 ? "leave blank below to use default" : ""}
                                            />
                                        );
                                    }}
                                    value={values?.[poa] ? values?.[poa] : ""}
                                    // onChange={(e) => setValue(e.target.value.split("-")[0].trim())}
                                    onSelect={(val) => {
                                        let new_values = { ...values };
                                        new_values[poa] = val;
                                        if (val.trim() === "") delete new_values[poa];
                                        if (Object.keys(new_values).length < 2) new_values = new_values?.["DEFAULT"];
                                        editCell.setEditCell({ ...editCell, value: new_values ? new_values : "" });
                                    }}
                                />
                            </BSL_Common.SectionRow>
                        );
                    })}
                </BSL_Common.SectionColumn>
            );
        },
        // autocompleteOptions: colours,
    },
    {
        id: "default_colour",
        label: "Default Colour",
        grouping: "Specifications",
        style: {
            width: "100px",
        },
        autocompleteOptions: colours,
    },
    {
        id: "texture_filename",
        label: "3D Model Texture",
        grouping: "Specifications",
        style: {
            width: "100px",
        },
        format: (val, row) => createThumb(val),
        select: texture_files,
    },
    {
        id: "bottomside_texture_filename",
        label: "Under Texture (insulated panel)",
        grouping: "Specifications",
        style: {
            width: "100px",
        },
        format: (val, row) => createThumb(val),
        select: bottom_texture_files,
    },
];

const skylight_columns = (roofSheetIDs, colours) => [
    {
        id: "Key",
        label: "Skylights",
        style: {
            width: "100px",
            position: "sticky",
            left: "0",
            zIndex: "3",
            fontWeight: "600",
        },
    },
    {
        id: "name",
        label: "Display Name",
        grouping: "SKYLIGHT SPECIFICATIONS",
        style: {
            width: "100px",
        },
    },
    {
        id: "roofsheet_id",
        label: "Skylight Roofsheet ID",
        grouping: "SKYLIGHT SPECIFICATIONS",
        style: {
            width: "100px",
        },
        autocompleteOptions: roofSheetIDs,
    },
    {
        id: "texture_filename",
        label: "3D Model Texture",
        grouping: "SKYLIGHT SPECIFICATIONS",
        style: {
            width: "100px",
        },
        format: (val, row) => createThumb(val),
        select: texture_files,
    },
    {
        id: "max_overhang",
        label: "Max Overhang",
        grouping: "SKYLIGHT SPECIFICATIONS",
        style: {
            width: "100px",
        },
    },
    {
        id: "colours",
        label: "Colours",
        grouping: "SKYLIGHT SPECIFICATIONS",
        style: {
            width: "100px",
        },
        autocompleteOptions: colours,
    },
    {
        id: "default_colour",
        label: "Default Colour",
        grouping: "SKYLIGHT SPECIFICATIONS",
        style: {
            width: "100px",
        },
        autocompleteOptions: colours,
    },
];

const roofsheeetGroup_columns = (roofSheetIDs, colour, parent) => [
    {
        id: "Key",
        label: "Key",
        style: {
            width: "200px",
            position: "sticky",
            left: "0",
            zIndex: "3",
            fontWeight: "600",
        },
        validate: "name",
    },
    {
        id: "name",
        label: "Display Name",
        style: {
            width: "100px",
        },
        validate: "name",
    },
    {
        id: "thumbnail",
        label: "Thumbnail",
        style: {
            width: "100px",
        },
        format: (value) => {
            if (value)
                return (
                    <img
                        style={{
                            maxHeight: "1.2rem",
                            width: "2.5rem",
                            objectFit: "contain",
                        }}
                        src={value}
                    />
                );
            return "";
        },
        editor: (editCell) => {
            const uploadFile = (e) => {
                if (e?.target?.files) handleFiles(e.target.files);
            };

            const handleFiles = (files) => {
                if (files.length === 0) return;
                let file = files[0];
                if (
                    file.name.toLowerCase().endsWith(".png") ||
                    file.name.toLowerCase().endsWith(".jpg") ||
                    file.name.toLowerCase().endsWith(".gif")
                ) {
                    if (file.size > 10000) {
                        alert("File is too big! Less thank 10kB please");
                        return;
                    }

                    
                    var reader = new FileReader();
                    reader.onload = function (e) {
                        
                        editCell.setEditCell({ ...editCell, value: e.target.result });
                        // setValue(e.target.result);
                    };
                    reader.readAsDataURL(file);
                }
            };

            return (
                <>
                    <BSL_ControlContainer
                        label={"Image"}
                        style={{ color: "white" }}
                        tight={true}
                        helperText={"max 10kb"}
                    >
                        <IconButton
                            aria-label="delete"
                            size="small"
                            onClick={() => editCell.setEditCell({ ...editCell, value: "" })}
                            style={{ color: "black", position: "absolute", right: "5px", marginTop: "12px" }}
                        >
                            <DeleteIcon />
                        </IconButton>
                        <input
                            accept="image/gif, image/jpeg, image/png"
                            // className={classes.input}
                            style={{ display: "none" }}
                            id="raised-button-file"
                            type="file"
                            onChange={uploadFile}
                        />
                        <label htmlFor="raised-button-file">
                            <div
                                style={{
                                    background: "rgb(134 134 134 / 36%)",
                                    cursor: "pointer",
                                    textAlign: "center",
                                }}
                            >
                                <div
                                    className="checkerBG"
                                    style={{
                                        backgroundColor: "white",
                                        minHeight: "50px",
                                    }}
                                >
                                    <img
                                        style={{
                                            maxHeight: "50px",
                                            maxWidth: "150px",
                                            textAlign: "center",
                                        }}
                                        src={editCell?.value}
                                    />
                                </div>

                                <div
                                    style={{
                                        textAlign: "center",
                                        color: "white",
                                        fontSize: "12px",
                                        height: "50px",
                                    }}
                                >
                                    {"Choose image file to upload"}
                                </div>
                            </div>
                        </label>
                    </BSL_ControlContainer>

                    {/* {param !== "NO BUTTON" && (
                        <BSL_Button onClick={() => editCell?saveValue(row, "Image_b64", value)}>UPDATE</BSL_Button>
                    )} */}
                </>
            );
        },
    },
    {
        id: "default_subtype",
        label: "Default Subtype",
        grouping: "defaults",
        style: {
            width: "100px",
        },
        autocompleteOptions: parent?.subtypes ? Object.keys(parent?.subtypes) : [],
        autocompleteShowFullList: true,
    },
    {
        id: "default_skylight",
        label: "Default Skylight",
        grouping: "defaults",
        style: {
            width: "100px",
        },
        autocompleteOptions: parent?.skylights ? Object.keys(parent?.skylights) : [],
        autocompleteShowFullList: true,
    },
    {
        id: "allow_cyclonic",
        label: "Allow Cyclonic",
        grouping: "specifications",
        style: {
            width: "100px",
        },
        format: (val, row) => (val === true ? "Yes" : "No"),
        select: [
            { Key: false, Display: "No" },
            { Key: true, Display: "Yes" },
        ],
    },
    {
        id: "single_span_only",
        label: "Single Span Only",
        grouping: "specifications",
        style: {
            width: "100px",
        },
        format: (val, row) => (val === true ? "Yes" : "No"),
        select: [
            { Key: false, Display: "No" },
            { Key: true, Display: "Yes" },
        ],
    },
    {
        id: "gutter_return_not_required",
        label: "Return Gutter NOT required",
        grouping: "specifications",
        style: {
            width: "100px",
        },
        format: (val, row) => (val === true ? "Yes" : "No"),
        select: [
            { Key: false, Display: "No" },
            { Key: true, Display: "Yes" },
        ],
    },
    {
        id: "double_beam_hip_required",
        label: "Double Hip Beam Area Join",
        grouping: "SUBTYPES - Cyclonic",
        style: {
            width: "100px",
        },
        format: (val, row) => (val === true ? "Yes" : "No"),
        select: [
            { Key: false, Display: "No" },
            { Key: true, Display: "Yes" },
        ],
    },
    {
        id: "texture_filename",
        label: "3D Model Texture",
        grouping: "specifications",
        style: {
            width: "100px",
        },
        format: (val, row) => createThumb(val),
        select: texture_files,
    },
    {
        id: "bottomside_texture_filename",
        label: "Under Texture (insulated panel)",
        grouping: "Specifications",
        style: {
            width: "100px",
        },
        format: (val, row) => createThumb(val),
        select: bottom_texture_files,
    },
    {
        id: "skylight_texture_filename",
        label: "Skylight Texture",
        grouping: "specifications",
        style: {
            width: "100px",
        },
        format: (val, row) => createThumb(val),
        select: texture_files,
    },
    {
        id: "min_pitch",
        label: "Min Pitch",
        grouping: "specifications",
        style: {
            width: "100px",
        },
        validate: "numbersOnly",
    },
    {
        id: "fan_bracket",
        label: "Fan Bracket",
        grouping: "specifications",
        style: {
            width: "100px",
        },
    },
    {
        id: "fan_bracket_default",
        label: "Default Number of fan brackets",
        grouping: "specifications",
        style: {
            width: "100px",
        },
        validate: "numbersOnly",
    },
    {
        id: "max_overhang",
        label: "Max Overhang",
        grouping: "specifications",
        style: {
            width: "100px",
        },
        validate: "numbersOnly",
    },
    {
        id: "min_front_overhang",
        label: "Min Front & Rear Overhang",
        grouping: "specifications",
        style: {
            width: "100px",
        },
        validate: "numbersOnly",
    },
    {
        id: "min_side_overhang",
        label: "Min Side Overhang",
        grouping: "specifications",
        style: {
            width: "100px",
        },
        validate: "numbersOnly",
    },
    {
        id: "max_side_overhang",
        label: "Max Side Overhang",
        grouping: "specifications",
        style: {
            width: "100px",
        },
        validate: "numbersOnly",
    },
    {
        id: "coverage",
        label: "Coverage",
        grouping: "specifications",
        style: {
            width: "100px",
        },
        validate: "numbersOnly",
    },
    {
        id: "skylight_coverage",
        label: "Skylight Coverage",
        grouping: "specifications",
        style: {
            width: "100px",
        },
        validate: "numbersOnly",
    },
    {
        id: "skylight_cyclonic_coverage",
        label: "Skylight Cyclonic Coverage",
        grouping: "specifications",
        style: {
            width: "100px",
        },
        validate: "numbersOnly",
    },
    {
        id: "gable_end_span_override",
        label: "Gable End Span Override",
        grouping: "specifications",
        style: {
            width: "100px",
        },
        validate: "numbersOnly",
    },
    {
        id: "gable_internal_span_override",
        label: "Gable Internal Span Override",
        grouping: "specifications",
        style: {
            width: "100px",
        },
        validate: "numbersOnly",
    },
    {
        id: "wall_fixing_spacing",
        label: "Wall Fix Spacing",
        grouping: "specifications",
        style: {
            width: "100px",
        },
        validate: "numbersOnly",
    },
];
const roofsheeetGroup_columns2 = (roofSheetIDs, colour, parent) => [
    {
        id: "subtypes",
        label: "Subtypes",
        grouping: "subtypes",
        colSpan: 16,
        style: {
            width: "100px",
        },
        format: (group_key, value, row, classes, getGroupHeaders, roofSheetIDs, colours, setEditCell, editCell) => {
            return (
                <TableContainer className={classes.container}>
                    <Table stickyHeader size="small" aria-label="sticky table">
                        <TableHead>
                            <TableRow>{getGroupHeaders(subtype_columns)}</TableRow>
                            <TableRow className={classes.headingRow}>
                                {subtype_columns().map((column) => {
                                    if (
                                        column.id === "bottomside_texture_filename" &&
                                        !group_key.toUpperCase().includes("BONDOR") &&
                                        !group_key.toUpperCase().includes("VERSICLAD") &&
                                        !group_key.toUpperCase().includes("APOLLO")
                                    )
                                        return null;
                                    return column?.hideInTable ? null : (
                                        <TableCell
                                            key={column.id}
                                            align={column.align}
                                            style={column?.style}
                                            className={classes.headingCellSubtype}
                                        >
                                            {column.label}
                                        </TableCell>
                                    );
                                })}
                                {/* <TableCell key={"Edit"} className={classes.headingCell}></TableCell> */}
                                <TableCell key={"Options"} className={classes.headingCell}></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {Object.keys(value).map((key, index) => {
                                return (
                                    <TableRow
                                        key={key}
                                        hover
                                        role="checkbox"
                                        tabIndex={-1}
                                        className={classes.row}
                                        style={{
                                            background: index % 2 === 0 ? "rgb(255 246 233)" : "blanchedalmond",
                                        }}
                                    >
                                        {subtype_columns(roofSheetIDs, colours).map((column) => {
                                            let display_value = value[key][column.id];
                                            if (column.id === "Key") display_value = key;

                                            if (
                                                column.id === "bottomside_texture_filename" &&
                                                !group_key.toUpperCase().includes("BONDOR") &&
                                                !group_key.toUpperCase().includes("VERSICLAD") &&
                                                !group_key.toUpperCase().includes("APOLLO")
                                            )
                                                return null;

                                            let warning = false;
                                            if (
                                                column?.format === undefined &&
                                                column.autocompleteOptions &&
                                                display_value
                                            ) {
                                                if (!column.autocompleteOptions.includes(display_value)) warning = true;
                                            }
                                            let deleteIcon = false;
                                            if (column.id === "Key") deleteIcon = true;

                                            let key_path =
                                                "roofsheet_types>" + group_key + ">subtypes>" + key + ">" + column.id;

                                            return (
                                                <TableCell
                                                    key={column.id}
                                                    className={classes.rowCell}
                                                    style={{ whiteSpace: "nowrap" }}
                                                    onClick={(e) => {
                                                        if (editCell?.anchorEl) {
                                                            setEditCell({ ...editCell, anchorEl: null });
                                                        } else {
                                                            setEditCell({
                                                                ...editCell,
                                                                anchorEl: e.currentTarget,
                                                                key: key,
                                                                key_path: key_path,
                                                                group_key: group_key,
                                                                row: row,
                                                                column: { ...column },
                                                                value: display_value,
                                                            });
                                                        }
                                                        e.stopPropagation();
                                                    }}
                                                >
                                                    {deleteIcon && (
                                                        <IconButton
                                                            aria-label="delete"
                                                            size="small"
                                                            onClick={(e) => {
                                                                setEditCell({
                                                                    ...editCell,
                                                                    anchorEl: e.currentTarget,
                                                                    key: key,
                                                                    key_path: key_path,
                                                                    // row: row,
                                                                    column: { ...column },
                                                                    value: "DELETE",
                                                                });
                                                                e.stopPropagation();
                                                            }}
                                                        >
                                                            <DeleteIcon />
                                                        </IconButton>
                                                    )}
                                                    {column.format
                                                        ? column.format(display_value, value[key])
                                                        : display_value}
                                                    {warning && (
                                                        <WarningIcon
                                                            style={{
                                                                width: "17px",
                                                                height: "13px",
                                                                color: "#e29d35",
                                                            }}
                                                        />
                                                    )}
                                                </TableCell>
                                            );
                                        })}
                                    </TableRow>
                                );
                            })}

                            <TableRow
                                hover
                                role="checkbox"
                                tabIndex={-1}
                                className={classes.row}
                                style={{
                                    background: value.length % 2 === 0 ? "rgb(255 246 233)" : "blanchedalmond",
                                }}
                            >
                                <TableCell
                                    className={classes.rowCell}
                                    style={{ whiteSpace: "nowrap" }}
                                    onClick={(e) => {
                                        if (editCell?.anchorEl) {
                                            setEditCell({ ...editCell, anchorEl: null });
                                        } else {
                                            setEditCell({
                                                ...editCell,
                                                anchorEl: e.currentTarget,
                                                key_path: "roofsheet_types>" + group_key + ">subtypes>ADD",
                                                group_key: group_key,
                                                row: row,
                                                column: { label: "New item Key" },
                                                value: "",
                                                template: {
                                                    roofsheet_id: "",
                                                    allow_non_trafficable: false,
                                                    roofsheet_id_non_trafficable: "",
                                                    default_colour: "",
                                                    colours: "",
                                                },
                                            });
                                        }
                                        e.stopPropagation();
                                    }}
                                    colSpan={subtype_columns.length}
                                >
                                    [add new]
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                    <Table stickyHeader size="small" aria-label="sticky table">
                        <TableHead>
                            {/* <TableRow>{getGroupHeaders(skylight_columns)}</TableRow> */}
                            <TableRow className={classes.skylightheadingRow} style={{ background: "#5ebba7" }}>
                                {skylight_columns().map((column) =>
                                    column?.hideInTable ? null : (
                                        <TableCell
                                            key={column.id}
                                            align={column.align}
                                            className={classes.headingCellSubtype}
                                            style={{ ...(column?.style ? column?.style : {}), background: "#5ebba7" }}
                                        >
                                            {column.label}
                                        </TableCell>
                                    )
                                )}
                                {/* <TableCell key={"Edit"} className={classes.headingCell}></TableCell> */}
                                <TableCell
                                    key={"Options"}
                                    className={classes.headingCell}
                                    style={{ background: "#5ebba7" }}
                                ></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {row?.skylights &&
                                Object.keys(row.skylights).map((key, index) => {
                                    return (
                                        <TableRow
                                            hover
                                            role="checkbox"
                                            tabIndex={-1}
                                            className={classes.row}
                                            style={{
                                                background: index % 2 === 0 ? "rgb(255 246 233)" : "blanchedalmond",
                                            }}
                                        >
                                            {skylight_columns(roofSheetIDs, colours).map((column) => {
                                                let display_value = row.skylights[key][column.id];
                                                if (column.id === "Key") display_value = key;
                                                let deleteIcon = false;
                                                if (column.id === "Key") deleteIcon = true;

                                                let warning = false;
                                                if (column.autocompleteOptions && display_value) {
                                                    if (!column.autocompleteOptions.includes(display_value))
                                                        warning = true;
                                                }
                                                let key_path =
                                                    "roofsheet_types>" +
                                                    group_key +
                                                    ">skylights>" +
                                                    key +
                                                    ">" +
                                                    column.id;

                                                return (
                                                    <TableCell
                                                        key={column.id}
                                                        className={classes.rowCell}
                                                        style={{ whiteSpace: "nowrap" }}
                                                        onClick={(e) => {
                                                            if (editCell?.anchorEl) {
                                                                setEditCell({ ...editCell, anchorEl: null });
                                                            } else {
                                                                setEditCell({
                                                                    ...editCell,
                                                                    anchorEl: e.currentTarget,
                                                                    key: key,
                                                                    key_path: key_path,
                                                                    group_key: group_key,
                                                                    row: row,
                                                                    column: { ...column },
                                                                    value: display_value,
                                                                });
                                                            }
                                                            e.stopPropagation();
                                                        }}
                                                    >
                                                        {deleteIcon && (
                                                            <IconButton
                                                                aria-label="delete"
                                                                size="small"
                                                                onClick={(e) => {
                                                                    setEditCell({
                                                                        ...editCell,
                                                                        anchorEl: e.currentTarget,
                                                                        key: key,
                                                                        key_path: key_path,
                                                                        // row: row,
                                                                        column: { ...column },
                                                                        value: "DELETE",
                                                                    });
                                                                    e.stopPropagation();
                                                                }}
                                                            >
                                                                <DeleteIcon />
                                                            </IconButton>
                                                        )}
                                                        {column.format
                                                            ? column.format(display_value, value[key])
                                                            : display_value}
                                                        {warning && (
                                                            <WarningIcon
                                                                style={{
                                                                    width: "17px",
                                                                    height: "13px",
                                                                    color: "#e29d35",
                                                                }}
                                                            />
                                                        )}
                                                    </TableCell>
                                                );
                                            })}
                                        </TableRow>
                                    );
                                })}

                            <TableRow
                                hover
                                role="checkbox"
                                tabIndex={-1}
                                className={classes.row}
                                style={{
                                    background: value.length % 2 === 0 ? "rgb(255 246 233)" : "blanchedalmond",
                                }}
                            >
                                <TableCell
                                    className={classes.rowCell}
                                    style={{ whiteSpace: "nowrap" }}
                                    onClick={(e) => {
                                        if (editCell?.anchorEl) {
                                            setEditCell({ ...editCell, anchorEl: null });
                                        } else {
                                            setEditCell({
                                                ...editCell,
                                                anchorEl: e.currentTarget,
                                                key_path: "roofsheet_types>" + group_key + ">skylights>ADD",
                                                group_key: group_key,
                                                row: row,
                                                column: { label: "New item Key" },
                                                value: "",
                                                template: {
                                                    name: "",
                                                    roofsheet_id: "",
                                                    default_colour: "",
                                                    colours: "",
                                                },
                                            });
                                        }
                                        e.stopPropagation();
                                    }}
                                    colSpan={subtype_columns.length}
                                >
                                    [add new]
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
            );
        },
    },
];

export default function ManageOfferingRoofSheetGroups(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const { value, saveValue, onClose, materials, brand } = props;

    const [editCell, setEditCell] = React.useState(null);

    const [roofSheetIDs, setRoofSheetIDs] = React.useState(materials?.["SHEETS_NAMES"]);
    const [colours, setColours] = React.useState([
        ...(materials?.["colour_arrays"] ? materials?.["colour_arrays"] : []),
        ...(materials?.["colour_map"] ? materials?.["colour_map"] : []),
    ]);

    if (editCell === null) {
        setEditCell({ setEditCell: setEditCell, saveValue: saveValue });
    }

    const getGroupHeaders = (columns) => {
        let grouping_headers = [];

        let last_grouping = undefined;
        let num_in_this_group = -1;
        let header_i = 0;
        for (let column of columns()) {
            if (column?.hideInTable) continue;
            let this_grouping = column?.grouping;
            if (
                this_grouping !== last_grouping ||
                (this_grouping === undefined && last_grouping) ||
                num_in_this_group > 8
            ) {
                //change in grouping. print cell

                let cell_style = {};
                if (header_i % 2 === 0) cell_style.background = "#936a2b !important";

                grouping_headers.push(
                    <TableCell
                        key={column.id}
                        className={
                            (last_grouping ? classes.categoryHeadingCell : classes.categoryHeadingCellBlank) +
                            " " +
                            classes.headingCell
                        }
                        style={cell_style}
                        colSpan={num_in_this_group + 1}
                    >
                        {last_grouping ? last_grouping : ""}
                    </TableCell>
                );
                header_i++;
                last_grouping = this_grouping;
                num_in_this_group = 0;
            } else {
                num_in_this_group++;
            }
        }

        if (num_in_this_group > 0) {
            let cell_style = {};
            if (header_i % 2 === 0) cell_style.background = "#936a2b !important";

            grouping_headers.push(
                <TableCell
                    key={"beam_col_end"}
                    className={
                        (last_grouping ? classes.categoryHeadingCell : classes.categoryHeadingCellBlank) +
                        " " +
                        classes.headingCell
                    }
                    colSpan={num_in_this_group + 1}
                >
                    {last_grouping ? last_grouping : ""}
                </TableCell>
            );
        }
        return grouping_headers;
    };

    return (
        // <BSL_Dialog
        //     title={"Edit Roof Sheet Groups"}
        //     open={true}
        //     // onClose={onClose}
        //     button1Text="Update"
        //     button1Click={() => {
        //         // saveValue(props.section, props.ref_key, props.row, "Spans", spans);
        //     }}
        //     button2Text="Cancel"
        //     button2Click={onClose}
        //     style={{ maxWidth: "initial" }}
        //     fullWidth={true}
        //     maxWidth={"xl"}
        // >
        <div
            style={{
                width: "fit-content",
                // position: "absolute",
                // height: "100%",
                // width: "100%",
                // top: "0px",
            }}
        >
            <BSL_Common.SectionRow>
                <TableContainer className={classes.container}>
                    <Table stickyHeader size="small" aria-label="sticky table">
                        {/* <TableHead>
                            <TableRow>{getGroupHeaders(roofsheeetGroup_columns)}</TableRow>
                            <TableRow className={classes.headingRow}>
                                {roofsheeetGroup_columns().map((column) =>
                                    column?.hideInTable ? null : (
                                        <TableCell
                                            key={column.id}
                                            align={column.align}
                                            style={column?.style}
                                            className={classes.headingCell}
                                        >
                                            {column.label}
                                        </TableCell>
                                    )
                                )}
                                <TableCell key={"Options"} className={classes.headingCell}></TableCell>
                            </TableRow>
                        </TableHead> */}
                        <TableBody>
                            {Object.keys(value).map((key, index) => {
                                return (
                                    <>
                                        <TableRow
                                            hover
                                            role="checkbox"
                                            tabIndex={-1}
                                            className={classes.row}
                                            style={{
                                                background: index % 2 === 0 ? "#e7ebee" : "#ffffff",
                                                width: "1200px",
                                                display: "flex",
                                                flexFlow: "wrap",
                                            }}
                                        >
                                            {roofsheeetGroup_columns(roofSheetIDs, colours, value[key]).map(
                                                (column) => {
                                                    if (
                                                        column.id === "bottomside_texture_filename" &&
                                                        !key.toUpperCase().includes("BONDOR") &&
                                                        !key.toUpperCase().includes("VERSICLAD") &&
                                                        !key.toUpperCase().includes("APOLLO")
                                                    )
                                                        return null;

                                                    let display_value = value[key][column.id];
                                                    if (column.id === "Key") display_value = key;

                                                    let deleteIcon = false;
                                                    if (column.id === "Key") deleteIcon = true;

                                                    let key_path = "roofsheet_types>" + key + ">" + column.id;

                                                    let warning = false;
                                                    if (column.autocompleteOptions && display_value) {
                                                        if (!column.autocompleteOptions.includes(display_value))
                                                            warning = true;
                                                    }

                                                    let template = {};
                                                    if (column?.style) template = column.style;

                                                    return (
                                                        <TableCell
                                                            key={column.id}
                                                            className={classes.rowCell}
                                                            style={{
                                                                ...template,
                                                                whiteSpace: column.id === "Key" ? "nowrap" : "normal",
                                                                fontWeight: column.id === "Key" ? 600 : "unset",
                                                                fontSize: column.id === "Key" ? "16px" : null,
                                                                width: column.id === "Key" ? "200px" : "100px",
                                                            }}
                                                            onClick={(e) => {
                                                                if (editCell?.anchorEl) {
                                                                    setEditCell({ ...editCell, anchorEl: null });
                                                                } else {
                                                                    setEditCell({
                                                                        ...editCell,
                                                                        anchorEl: e.currentTarget,
                                                                        key: key,
                                                                        key_path: key_path,
                                                                        // row: row,
                                                                        column: { ...column },
                                                                        value: display_value,
                                                                    });
                                                                }
                                                                e.stopPropagation();
                                                            }}
                                                        >
                                                            {deleteIcon && (
                                                                <IconButton
                                                                    aria-label="delete"
                                                                    size="small"
                                                                    onClick={(e) => {
                                                                        setEditCell({
                                                                            ...editCell,
                                                                            anchorEl: e.currentTarget,
                                                                            key: key,
                                                                            key_path: key_path,
                                                                            // row: row,
                                                                            column: { ...column },
                                                                            value: "DELETE",
                                                                        });
                                                                        e.stopPropagation();
                                                                    }}
                                                                >
                                                                    <DeleteIcon />
                                                                </IconButton>
                                                            )}
                                                            {<span style={{ fontWeight: 600 }}>{column.label}: </span>}
                                                            {column.id !== "Key" && <br />}
                                                            {column.format
                                                                ? column.format(display_value, value[key])
                                                                : display_value}

                                                            {warning && (
                                                                <WarningIcon
                                                                    style={{
                                                                        width: "17px",
                                                                        height: "13px",
                                                                        color: "#e29d35",
                                                                    }}
                                                                />
                                                            )}
                                                        </TableCell>

                                                        // format: (group_key, value, row, classes, getGroupHeaders, roofSheetIDs, colours, setEditCell, editCell)
                                                    );
                                                }
                                            )}
                                        </TableRow>
                                        <TableRow
                                            role="checkbox"
                                            tabIndex={-1}
                                            className={classes.row + " " + classes.noHover}
                                            style={{
                                                background: index % 2 === 0 ? "#e7ebee" : "#ffffff",
                                            }}
                                        >
                                            {roofsheeetGroup_columns2(roofSheetIDs, colours, value[key]).map(
                                                (column) => {
                                                    if (
                                                        column.id === "bottomside_texture_filename" &&
                                                        !key.toUpperCase().includes("BONDOR") &&
                                                        !key.toUpperCase().includes("VERSICLAD") &&
                                                        !key.toUpperCase().includes("APOLLO")
                                                    )
                                                        return null;

                                                    let display_value = value[key][column.id];
                                                    if (column.id === "Key") display_value = "";

                                                    let key_path = "roofsheet_types>" + key + ">" + column.id;

                                                    let warning = false;
                                                    if (column.autocompleteOptions && display_value) {
                                                        if (!column.autocompleteOptions.includes(display_value))
                                                            warning = true;
                                                    }

                                                    return (
                                                        <TableCell
                                                            key={column.id}
                                                            className={classes.rowCell + " " + classes.noHover}
                                                            style={{
                                                                whiteSpace: column.id === "Key" ? "nowrap" : "normal",
                                                            }}
                                                            colSpan={column.colSpan ? column.colSpan : 1}
                                                            onClick={(e) => {
                                                                if (editCell?.anchorEl) {
                                                                    setEditCell({ ...editCell, anchorEl: null });
                                                                } else {
                                                                    setEditCell({
                                                                        ...editCell,
                                                                        anchorEl: e.currentTarget,
                                                                        key: key,
                                                                        key_path: key_path,
                                                                        // row: row,
                                                                        column: { ...column },
                                                                        value: display_value,
                                                                    });
                                                                }
                                                                e.stopPropagation();
                                                            }}
                                                        >
                                                            {column.format
                                                                ? column.format(
                                                                      key,
                                                                      display_value,
                                                                      value[key],
                                                                      classes,
                                                                      getGroupHeaders,
                                                                      roofSheetIDs,
                                                                      colours,
                                                                      setEditCell,
                                                                      editCell
                                                                  )
                                                                : display_value}

                                                            {warning && (
                                                                <WarningIcon
                                                                    style={{
                                                                        width: "17px",
                                                                        height: "13px",
                                                                        color: "#e29d35",
                                                                    }}
                                                                />
                                                            )}
                                                        </TableCell>

                                                        // format: (group_key, value, row, classes, getGroupHeaders, roofSheetIDs, colours, setEditCell, editCell)
                                                    );
                                                }
                                            )}
                                        </TableRow>
                                    </>
                                );
                            })}
                            <TableRow
                                hover
                                role="checkbox"
                                tabIndex={-1}
                                className={classes.row}
                                style={{
                                    background: value.length % 2 === 0 ? "rgb(255 246 233)" : "blanchedalmond",
                                }}
                            >
                                <TableCell
                                    className={classes.rowCell}
                                    style={{ whiteSpace: "nowrap" }}
                                    onClick={(e) => {
                                        if (editCell?.anchorEl) {
                                            setEditCell({ ...editCell, anchorEl: null });
                                        } else {
                                            setEditCell({
                                                ...editCell,
                                                anchorEl: e.currentTarget,
                                                key_path: "roofsheet_types>ADD",
                                                column: { label: "New item Key" },
                                                value: "",
                                                template: {
                                                    name: "",
                                                    subtypes: {},
                                                    skylights: {},
                                                    default_skylight: "",
                                                    default_subtype: "",
                                                    default_colour: "",
                                                    thumbnail: "",
                                                    texture_filename: "",
                                                    skylight_texture_filename: "",
                                                    texture_normal_filename: "",
                                                    min_pitch: 5,
                                                    max_overhang: 500,
                                                    coverage: 760,
                                                },
                                            });
                                        }
                                        e.stopPropagation();
                                    }}
                                    colSpan={subtype_columns.length}
                                >
                                    [add new]
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
            </BSL_Common.SectionRow>
            <Popper
                key={editCell}
                anchorEl={editCell?.anchorEl}
                placement="bottom-start"
                open={editCell?.anchorEl}
                disablePortal={false}
                modifiers={{
                    flip: {
                        enabled: true,
                    },
                    preventOverflow: {
                        enabled: true,
                        boundariesElement: "scrollParent",
                    },
                    arrow: {
                        enabled: true,
                        element: editCell?.anchorEl,
                    },
                }}
                onClick={(e) => {
                    // e.stopPropagation();
                }}
            >
                <Paper
                    style={{
                        padding: "0px 5px 5px 5px",
                        background: "rgb(255 179 67 / 96%)",
                        textAlign: "center",
                        paddingTop: "2px",
                        minWidth: "50px",
                    }}
                >
                    {/* <div
                        // id="draggable-dialog-title"
                        style={{
                            position: "absolute",
                            width: "100%",
                            height: "19px",
                        }}
                    >
                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                            <div className={classes.drag_bar} />
                            <div className={classes.drag_bar} />
                            <div className={classes.drag_bar} />
                        </div>
                    </div> */}
                    <IconButton
                        aria-label="delete"
                        size="small"
                        onClick={() => setEditCell({ ...editCell, anchorEl: null })}
                        style={{ color: "white", position: "absolute", right: "5px" }}
                    >
                        <CloseIcon />
                    </IconButton>

                    {editCell?.value === "DELETE" ? (
                        <>
                            <BSL_Button
                                onClick={() => {
                                    saveValue("MASTER", editCell.key_path, "DELETE");
                                    setEditCell({ ...editCell, anchorEl: null });
                                }}
                                secondary
                            >
                                DELETE
                            </BSL_Button>
                            <BSL_Button
                                onClick={() => {
                                    setEditCell({ ...editCell, anchorEl: null });
                                }}
                            >
                                CANCEL
                            </BSL_Button>
                        </>
                    ) : editCell?.column?.editor ? (
                        editCell?.column?.editor(editCell, brand)
                    ) : editCell?.column?.select ? (
                        <>
                            <SegmentedButtonGroup
                                label={editCell?.column?.label}
                                style={{ width: "300px", flex: "none" }}
                                value={editCell?.value}
                                tight={true}
                                items={editCell?.column?.select}
                                onChange={(e, val) => {
                                    setEditCell({ ...editCell, value: val });
                                    // e.stopPropagation();
                                }}
                            />
                        </>
                    ) : (
                        <>
                            <Autocomplete
                                items={
                                    editCell?.column?.autocompleteOptions ? editCell?.column?.autocompleteOptions : []
                                }
                                shouldItemRender={(item, value) => {
                                    if (editCell?.column?.autocompleteShowFullList) return true;
                                    if (item.toLowerCase().startsWith(value.toLowerCase().substring(0, 3))) return true;
                                    if (item.toLowerCase().indexOf(value.toLowerCase()) > -1) return true;
                                    return false;
                                }}
                                getItemValue={(item) => item}
                                autoHighlight={false}
                                renderItem={(item, highlighted) => (
                                    <div
                                        key={item.id}
                                        style={{ backgroundColor: highlighted ? "#eee" : "transparent" }}
                                    >
                                        {item}
                                    </div>
                                )}
                                menuStyle={{
                                    zIndex: "999999",
                                    position: "absolute",
                                    backgroundColor: "whitesmoke",
                                    boxShadow: "1px 1px 4px",
                                    fontSize: "12px",
                                    left: "auto",
                                    top: "auto",
                                    marginLeft: "9px",
                                    // marginTop: "-33px",
                                    lineHeight: 1.4,
                                    width: "350px",
                                    textAlign: "left",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                }}
                                inputProps={{
                                    style: {
                                        font: "200 12px Univers45",
                                        width: "95%",
                                        padding: "4px 0px 4px 8px !important",
                                    },
                                }}
                                renderInput={(props) => {
                                    return (
                                        <BSL_TextInput
                                            label={editCell?.column?.label}
                                            style={{ width: "300px", color: "white" }}
                                            value={editCell?.value}
                                            autoFocus
                                            tight={true}
                                            allCaps={editCell?.column?.allCaps}
                                            preValidate={editCell?.column?.validate}
                                            InputProps={{
                                                style: { fontSize: "80%" },
                                                ...props,
                                            }}
                                            // onEnter={(e) =>
                                            //     saveValue(
                                            //         editCell.section,
                                            //         editCell.key,
                                            //         editCell.row,
                                            //         editCell?.column?.id,
                                            //         e.target.value
                                            //     )
                                            // }
                                            onChange={(val) => {
                                                setEditCell({ ...editCell, value: val });
                                            }}
                                            // helperText={editCellHelperText}
                                        />
                                    );
                                }}
                                value={editCell?.value}
                                // onChange={(e) => setValue(e.target.value.split("-")[0].trim())}
                                onSelect={(val) => setEditCell({ ...editCell, value: val })}
                            />
                        </>
                    )}
                    <br />
                    {editCell?.value !== "DELETE" && (
                        <BSL_Button
                            onClick={() => {
                                saveValue("MASTER", editCell.key_path, editCell.value, editCell.template);
                                setEditCell({ ...editCell, anchorEl: null });
                            }}
                        >
                            UPDATE
                        </BSL_Button>
                    )}
                </Paper>
            </Popper>
        </div>
        // </BSL_Dialog>
    );
}
